import { ConflictError } from "./conflict-error";

// Thrown when a transfer carrier is deleted while put-aways are still standing on it.
//
// The refusal exists because the foreign key **cascades**: deleting the trolley would delete its
// open legs with it, and each of those legs is material already counted as returned at the gate.
// The rows would vanish from the reconciliation's open arm and never reach a shelf, so the goods
// would be physically in the building and accounted for nowhere — a silent loss rather than a
// visible error.
//
// Unloading the trolley clears it: a completed leg is out of the count, and its ledger row is the
// durable record of where the material went. 409: the request is well formed and it is the
// warehouse that is not in a state for it.
export class TransferCarrierInUseError extends ConflictError {
	constructor() {
		super("stock.transfer_carrier_in_use");
		this.name = "TransferCarrierInUseError";
	}
}
